import React, { useEffect, useState } from "react";
import "./deathDashboard.css";
import { StartMessageDashboard } from "./StartMessageDashboard";
import { AudioVideoDashboard } from "./AudioVideoDashboard";
import { ChecklistDashboard } from "./ChecklistDashboard";
import { BurialExpenseDashboard } from "./BurialExpenseDashboard";
import { PasswordListDashboard } from "./PasswordListDashboard";
import { EmailTextDashboard } from "./EmailTextDashboard";
import { UpcomingBills } from "./UpcomingBills";
import { ContactListDashboard } from "./ContactListDashboard";
import { AssetsDashboard } from "./AssetsDashboard";
import { PersonalItemsDashboard } from "./PersonalItemsDashboard";
import { PersonalInstructionDashboard } from "./PersonalInstructionDashboard";
import { LitigationDashboard } from "./LitigationDashboard";
import { ImportantDocumnetsDashboard } from "./ImportantDocumnetsDashborad";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../redux/slices/loginSlice";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
export const DeathDashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const [loading, setLoading] = useState(false);
  const handleLoading = () => {
    setLoading(!loading);
    console.log("loading", loading);
  };
  const getUserRole = async () => {
    try {
      let outputObj = {};
      let data = await DEATH_API.getUpdatedRole();
      if (data && data.data) {
        let loginRole;
        if (data.data.roles) {
          loginRole = data.data.roles;
        }
        let recursive = (obj, name) => {
          for (let key in obj) {
            if (typeof obj[key] == "object") {
              recursive(obj[key], name + "_" + key);
            } else {
              outputObj[key] = obj[key];
            }
          }
        };
        recursive(loginRole, "loginRole");
        if (
          outputObj &&
          outputObj.name &&
          outputObj.name === "inactiveClient"
        ) {
          localStorage.setItem("role", JSON.stringify(outputObj.name));
          history.push("/payment");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  // useEffect(() => {
  //   getUserRole();
  // }, []);
  return (
    <div>
      <div className="MainDashboard">
        <div className="mainContainerLeft">
          <div className="subContainerMain">
            <div className="subContainer">
              <div className="subContainer1">
                <div
                  className="messageCard"
                  onClick={() => {
                    const ID = localStorage.getItem("accessId");
                    if (
                      (userRole === "protrustee" || userRole === "trustee") &&
                      ID === null
                    ) {
                      history.push("/delgateAccess");
                    } else {
                      dispatch(setActiveStep(0));
                      history.push("/protector/death");
                    }
                  }}>
                  <StartMessageDashboard role={userRole} />
                </div>
                <div
                  className="audioCard"
                  style={{
                    pointerEvents: userRole === "trustee" ? "none" : "",
                    opacity: userRole === "trustee" ? "0.5" : "1",
                  }}
                  onClick={() => {
                    if (userRole !== "protrustee") {
                      dispatch(setActiveStep(1));
                    } else {
                      dispatch(setActiveStep(2));
                    }
                    history.push("/protector/death");
                  }}>
                  <AudioVideoDashboard role={userRole} />
                </div>
              </div>
              <div className="subContainerMain2" style={{ flexGrow: "1" }}>
                <div
                  className="messageCard"
                  style={{
                    pointerEvents: userRole === "trustee" ? "none" : "",
                    opacity: userRole === "trustee" ? "0.5" : "1",
                  }}
                  onClick={() => {
                    dispatch(setActiveStep(6));
                    history.push("/protector/death");
                  }}>
                  <BurialExpenseDashboard role={userRole} />{" "}
                </div>
                <div
                  className="messageCard"
                  style={{
                    pointerEvents: userRole === "trustee" ? "none" : "",
                    opacity: userRole === "trustee" ? "0.5" : "1",
                  }}
                  onClick={() => {
                    dispatch(setActiveStep(7));
                    history.push("/protector/death");
                  }}>
                  <PasswordListDashboard role={userRole} />
                </div>
              </div>
            </div>
            <div
              className="checklistCard"
              style={{
                pointerEvents: userRole === "trustee" ? "none" : "",
                opacity: userRole === "trustee" ? "0.5" : "1",
              }}
              onClick={() => {
                if (userRole !== "protrustee") {
                  dispatch(setActiveStep(2));
                } else {
                  dispatch(setActiveStep(1));
                }
                history.push("/protector/death");
              }}>
              <ChecklistDashboard role={userRole} />
            </div>
          </div>
          <div className="subContainerMain2">
            <div className="subContainerLower">
              <div className="subContainerMain">
                <div
                  className="contactlistCard"
                  style={{
                    pointerEvents: userRole === "trustee" ? "none" : "",
                    opacity: userRole === "trustee" ? "0.5" : "1",
                  }}
                  onClick={() => {
                    if (userRole !== "protrustee") {
                      dispatch(setActiveStep(4));
                    } else {
                      dispatch(setActiveStep(5));
                    }
                    history.push("/protector/death");
                  }}>
                  <ContactListDashboard role={userRole} />
                </div>
              </div>
              <div className="subContainerMain2">
                <div
                  className="assetsCard"
                  style={{
                    pointerEvents: userRole === "trustee" ? "none" : "",
                    opacity: userRole === "trustee" ? "0.5" : "1",
                  }}
                  // onClick={() => {
                  //   dispatch(setActiveStep(9));
                  //   history.push("/protector/death");
                  // }}
                >
                  <AssetsDashboard role={userRole} />{" "}
                </div>
                <div
                  className="personalItemsCard"
                  style={{
                    pointerEvents: userRole === "trustee" ? "none" : "",
                    opacity: userRole === "trustee" ? "0.5" : "1",
                  }}
                  onClick={() => {
                    dispatch(setActiveStep(12));
                    history.push("/protector/death");
                  }}>
                  <PersonalItemsDashboard role={userRole} />
                </div>
              </div>
            </div>
            <div className="personalLitigation">
              <PersonalInstructionDashboard role={userRole} />
              <LitigationDashboard role={userRole} />
            </div>
          </div>
        </div>
        <div className="mainContainerRight">
          <EmailTextDashboard role={userRole} />{" "}
          <UpcomingBills role={userRole} />{" "}
          <ImportantDocumnetsDashboard role={userRole} />{" "}
        </div>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
